module.exports = __webpack_public_path__ + "static/media/blue_ballon.10b005f9.png";